import { useEventSettings } from '../events/useEventSettings';

export function useEventChatEnabled(eventId) {
    const settings = useEventSettings(eventId);
    return !settings?.disable_chat;
}
